import { Injectable, Inject } from '@angular/core';
import { Title, DOCUMENT } from '@angular/platform-browser';
import { Headers, Http, Response, RequestOptions } from '@angular/http';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { AlertsService } from './alerts.service';
import { Location } from '@angular/common';
import { Subject } from 'rxjs';
import { Observable } from 'rxjs/Observable';
import swal from 'sweetalert2';
import * as $ from 'jquery';

@Injectable( )
export class GlobalService {

  preloaderVisible:            Subject<any>       = new Subject( );
  productRefPage:              Subject<any>       = new Subject( );
  lastPositionOfProjectZones:  Subject<any>       = new Subject( );
  wipedZonesSubject:           Subject<any>       = new Subject( );
  documentTitleSubject:        Subject<string>    = new Subject( );
  bodyOverflowLockedSubject:   Subject<boolean>   = new Subject( );
  historyPopupVisibleSubject:  Subject<boolean>   = new Subject( );
  displayWidthSubject:         Subject<number>    = new Subject( );

  scrollPageSubject:           Subject<number>    = new Subject( );

  historyPopupVisible: boolean = false;

  displayWidth: number = 1024;
  
  redirectTimeout: number = 1500;
  $iframeOfFHError: JQuery = $( '<iframe/>' );

  prevRoute: string = '';
  currRoute: string = '';

  productRefPageURL: string = '/products-list';

  lastPositionOfProjectZonesData: any = {
    offset: 0,
    projectID: 0
  };

  documentTitlePrefix: string = 'Lumi Genie';
  documentTitle: string = '';

  wipedZones: Array<number> = [];

  constructor (
    @Inject(DOCUMENT) private document: Document,
    private http: Http,
    private _location: Location,
    private activatedRoute: ActivatedRoute, 
    private router: Router,
    private alerts: AlertsService,
    private titleService: Title
    ) { 

    // Set starter display width
    this.displayWidth = this.document.body.clientWidth;

    // Set default
    this.setProductRefPage( '/products-list' );
    this.setPZposition( 0, 0 );

    // Getting prev route
    router.events.subscribe( event => {

      this.prevRoute = this.currRoute;
      if ( event instanceof NavigationEnd ) this.currRoute = event.url;

      this.getProductRefPage( ).subscribe( data => { this.productRefPageURL = data.url;          });
      this.getPZposition( ).    subscribe( data => { this.lastPositionOfProjectZonesData = data; });

    });

    this.getDocumentTitle( ).subscribe( documentTitleSufix => {
      this.documentTitle = '';
      if ( documentTitleSufix != '' ) this.documentTitle = ' - ' + documentTitleSufix;
      this.titleService.setTitle( this.documentTitlePrefix + this.documentTitle );
    });

    // Control of overflow body
    this.getfixedBodyOverflow( ).subscribe( isLocked => this.fixingBodyOverflow( isLocked ) );


    // Notes history popup visibility control
    this.getHPVisibility( ).subscribe( isVisible => {
      this.historyPopupVisible = isVisible;
      this.fixingBodyOverflow( this.historyPopupVisible ); 
    });

    // Update display width on resize
    this.getDisplayWidth( ).subscribe( _width => { this.displayWidth = _width; });

  }

  getPZposition         ( ): Observable<any> { return this.lastPositionOfProjectZones.asObservable( ); }
  getProductRefPage     ( ): Observable<any> { return this.productRefPage.asObservable( );             }
  getWipedZones         ( ): Observable<any> { return this.wipedZonesSubject.asObservable( );          }
  getDocumentTitle      ( ): Observable<any> { return this.documentTitleSubject.asObservable( );       }
  getfixedBodyOverflow  ( ): Observable<any> { return this.bodyOverflowLockedSubject.asObservable( );  }
  getHPVisibility       ( ): Observable<any> { return this.historyPopupVisibleSubject.asObservable( ); }
  getDisplayWidth       ( ): Observable<any> { return this.displayWidthSubject.asObservable( );        }
  getScrollPage         ( ): Observable<any> { return this.scrollPageSubject.asObservable( );          }


  setPZposition              ( id: number, offset: number ) { this.lastPositionOfProjectZones.next({ projectID: id, offset: offset }); }
  setProductRefPage          ( url: string )                { this.productRefPage.next({ url: url });                                  }
  setDocumentTitle           ( title: string )              { this.documentTitleSubject.next( title );                                 }
  fixBodyOverflow            ( isLocked: boolean )          { this.bodyOverflowLockedSubject.next( isLocked );                         }
  changeHPVisibility         ( isVisible: boolean )         { this.historyPopupVisibleSubject.next( isVisible );                       }
  updateWindowResize         ( _width: number )             { this.displayWidthSubject.next( _width );                                 }
  updateTriggeringScrollPage ( isScroll: any )              { this.scrollPageSubject.next( isScroll );                                 }


  addWipedZone ( wipedZoneID: number ) { 
    this.removeWipedZone( wipedZoneID );
    this.wipedZones.push( wipedZoneID );
    this.wipedZonesSubject.next( this.wipedZones );
  };

  removeWipedZone ( unwipedZoneID: number ) {
    let _index = this.wipedZones.indexOf( unwipedZoneID );
    if ( _index > -1 ) {
      this.wipedZones.splice( _index, 1 );
      this.wipedZonesSubject.next( this.wipedZones );
    }
  }


  goBack ( ) { this._location.back( ); }

  showPreloader ( ) {
    this.preloaderVisible.next( true );
    return this.preloaderVisible;
   }
   

  hidePreloader ( ) {
    this.preloaderVisible.next( false );
    return this.preloaderVisible;
  } 



  defaultSuccessMessage ( data ) {
    this.alerts.clearData( ).subscribe( );
    let messageData = {
      title: 'Success',
      html: data.html || '', 
      showConfirmButton: false
    };
    this.successMessage( messageData );
    setTimeout( ( ) => {
      swal.close( );
      this.redirect( data.redirect || '/' );
    }, 3000 );
  }


  defaultErrorCallback ( message?: string, autoclose?: boolean ) {
    let data = {
      type: 'error',
      title: '',
      html: message || 'We got some error here...'
    }
    this.errorMessage( data );
    if ( autoclose !== false ) setTimeout( ( ) => { swal.close( ); }, 6000 );
  }


  successMessage ( data ) {

    if ( data.title === undefined ) data.title = '';
    if ( data.html === undefined ) data.html = '';
    if ( data.type === undefined ) data.type = 'success';
    if ( data.confirmButtonColor === undefined ) data.confirmButtonColor = "#8ac440";

    swal( data );
  }


  errorMessageFH ( message ) {
    let messageData = {
      title: 'Error!',
      html: message || '', 
      showConfirmButton: true
    };
    // onClose: ( ) => location.reload( )
    this.errorMessage( messageData );
  }


  confirmMessage ( data, cb ) {

    let messageData = {
      title: "Warning!",
      html: data.message || "Are you sure want to do this?",
      showCancelButton: true,
      confirmButtonColor: "#8ac440"
    };
    
    messageData['type'] = 'question';
    if ( data.confirmButtonText ) messageData['confirmButtonText'] = data.confirmButtonText;
    if ( data.cancelButtonText ) messageData['cancelButtonText'] = data.cancelButtonText;

    swal( messageData ).then( ( result ) => { 
      if ( this.isFunction( cb ) ) cb( ); 
    }).catch( swal.noop );

  }


    
  errorMessage ( data ) {

    if ( data.title === undefined ) data.title = '';
    if ( data.html === undefined ) data.html = '';
    if ( data.type === undefined ) data.type = 'error';
    if ( data.confirmButtonColor === undefined ) data.confirmButtonColor = "#fd3753";
    if ( data.confirmButtonText === undefined ) data.confirmButtonText = "OK";

    swal( data );
  }



  redirect ( url ) {
    this.router.navigate( [ url ] );
  }


  // Check if entity is function for callbacks etc.
  isFunction ( entity: any ) {
      return ( typeof entity === 'function' );
  }



  // Custom wrapper for GET
  getRequest ( URL, callback ) {
      this.showPreloader( ).subscribe( );
      this.http.get( '/api/'+URL, )
      .subscribe( ( data: Response ) => {
          if ( this.isFunction( callback ) ) callback( data );
          this.hidePreloader( ).subscribe( );
      });
  }


  // Open link in new tab
  openLinkNewTab ( url ) {
    window.open( url, "_blank" );
  }




  // Custom wrapper for POST
  postRequestToken ( URL, data, token, callback, withoutPreloader?, defaultGateway?, uploadingFile? ) {
      if ( withoutPreloader != true ) this.showPreloader( ).subscribe( );
      let _options;

      let headers = new Headers(
        { 
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token 
        });

      if ( uploadingFile == true ) {
        headers = new Headers({ 
          'Authorization': 'Bearer ' + token 
        });

        // headers.append('Content-Type', 'multipart/form-data');
        headers.append('Accept', 'application/json');
      }

      _options = new RequestOptions({ headers: headers });

      let _url = '/api/'+URL;
      if ( defaultGateway == true ) _url = URL;

      this.http.post( 
        _url,
        data,
        _options
        )
      .subscribe( 
        // Success
        ( data: Response ) => {
          if ( this.isFunction( callback ) ) callback( data );
          if ( withoutPreloader != true ) this.hidePreloader( ).subscribe( );
        }, 
        // Error
        ( response ) => {
          if ( response.status == '401' ) {
            if ( this.isFunction( callback ) ) callback( response );
            if ( withoutPreloader != true ) this.hidePreloader( ).subscribe( );
          }
          if ( response.status == '500' ) {
            if ( withoutPreloader != true ) this.hidePreloader( ).subscribe( );
            let element: JQuery;
            let errorName: any = '';
            try {
              element = this.$iframeOfFHError.html( response.text( ) ).find( '.break-long-words.trace-message' );
              errorName = element.html( ( index, html ) => { return html+'<br />'; } );
            } catch ( exception ) {
              errorName = 'Undefined error, try to reload page...';
            }
            this.errorMessageFH( errorName );
          }
      } );
  }



  // Custom wrapper for POST
  postRequest ( URL, data, options, callback, withoutPreloader? ) {
      if ( withoutPreloader != true ) this.showPreloader( ).subscribe( );
      let _options = options;

      let headers = new Headers({ 'Content-Type': 'application/json' });
      _options = new RequestOptions({ headers: headers });


      this.http.post( 
        '/api/'+URL,
        data,
        _options
        )
      .subscribe( ( data: Response ) => {
          if ( this.isFunction( callback ) ) callback( data );
          if ( withoutPreloader != true ) this.hidePreloader( ).subscribe( );
      });
  }


  NFFocusMoney ( event ) {
    if ( event.target.value == '0' || event.target.value == '0.00' || !event.target.value ) {
      event.target.value = '0.00';
      if ( event.target.value == '0.00' ) event.target.setSelectionRange( 0, 4 );
      else event.target.setSelectionRange( 0, 1 );
    }
    if ( event.target.value.indexOf( '.' ) == -1 ) {
      event.target.value += '.00';
      event.target.setSelectionRange( 0, 0 );
    }
  }

  NFBlurMoney ( event, val? ) {
    if ( event.target.value == '0' || !event.target.value ) {
      event.target.value = '0.00';
      if ( val !== undefined ) val = 0;
    }
    if ( event.target.value.indexOf( '.' ) == -1 ) {
      event.target.value += '.00';
    }
  }

  NFFocus ( event ) {
    if ( event.target.value == 0 ) event.target.value = '';
  }

  // NFPaste ( event ) {
  //   console.log( event );
  //   data = data.replace( );
  // }

  checkNumberField ( event ) {


    // Allow: backspace, delete, tab, escape, enter and .
    if (   [46, 8, 9, 27, 13, 190, 45].indexOf( event.charCode ) !== -1 ||
         // Allow: Ctrl+A, Command+A
        ( ( [ 'a', 'A', 'c', 'C', 'v', 'V' ].indexOf( event.key ) !== -1 ) && ( event.ctrlKey === true || event.metaKey === true ) ) || 
        // ( ( event.charCode === 65 || event.charCode === 97 ) && ( event.ctrlKey === true || event.metaKey === true ) ) || 

         // Allow: home, end, left, right, down, up

         // Firefox fix
        ( [ 'End', 'Home', 'Backspace', 'Enter', 'F5', 'ArrowLeft', 'ArrowDown', 'ArrowUp', 'ArrowRight', 'Delete' ].indexOf( event.key ) !== -1 ) || 
        
         // Disallow: '
        (  event.charCode >= 35 && event.charCode <= 40 && event.charCode !== 39 ) ) {
         // let it happen, don't do anything
        if ( !event.shiftKey ) return;
    }
    // Ensure that it is a number and stop the keypress
    if ( event.shiftKey || event.charCode < 48 || event.charCode > 57 ) {
        event.preventDefault( );
    }

  }


  cloneObject ( _object: any ) {
    let cloneObj = {};
    for (var attribute in _object) {
        if (typeof _object[attribute] === "object") {
            cloneObj[attribute] = this.cloneObject( _object[attribute] );
        } else {
            cloneObj[attribute] = _object[attribute];
        }
    }
    return cloneObj;
  }


  parseDate ( _date: any ) {
    if ( !_date || _date === '' ) return '';
    try {
      return new Date( _date );
    } catch ( exception ) {
      console.warn( exception );
      return '';
    }
  }


  fixingBodyOverflow ( isLocked: boolean ) {
    if ( isLocked == false ) {
      $( this.document.body ).removeClass( 'overflow-locked' );
    } else {
      $( this.document.body ).removeClass( 'overflow-locked' ).addClass( 'overflow-locked' );
    }
  }

}



// WEBPACK FOOTER //
// /root/anvel/angular/app/services/global.service.ts